import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, UtilsService } from '../../xform-compat';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';

/**
 * Data service to handle system health
 */
@Injectable({
  providedIn: 'root'
})
export class SystemHealth extends RmsBasicCrudService<any> {
  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets data health
   * @returns {Observable<any>}
   */
  getDataHealth(): Observable<any> {
    return super.getData('/api/rms/datahealth');
  }

  /**
   * Gets jobs Description
   * @returns {Observable<any>}
   */
  getJobsDescription(): Observable<any> {
    return super.getData('/api/rms/jobs/descriptions');
  }

  /**
   * Gets jobs Description by date
   * @param date
   * @param executionType
   * @returns {Observable<any>}
   */
  getJobsDescriptionByDate(date, executionType): Observable<any> {
    return super.getData(
      `/api/rms/jobs/descriptions?date=${date}&executiontype=${executionType}`
    );
  }

  /**
   * Gets jobs history by jobType
   * @param jobType
   * @param pageSize
   * @param pageNumber
   * @returns {Observable<any>}
   */
  getJobHistoryByType(jobType, pageSize, pageNumber): Observable<any> {
    return super.getData(
      `/api/rms/jobs?jobtype=${jobType}&pagesize=${pageSize}&page=${pageNumber}&direction=desc`
    );
  }
}
